var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8721 4.81013C10.8727 2.47272 7.53865 1.84396 5.0336 3.98433C2.52855 6.1247 2.17587 9.70329 4.1431 12.2347C5.77872 14.3394 10.7287 18.7784 12.351 20.2151C12.5325 20.3759 12.6233 20.4563 12.7291 20.4878C12.8215 20.5154 12.9226 20.5154 13.015 20.4878C13.1209 20.4563 13.2116 20.3759 13.3931 20.2151C15.0154 18.7784 19.9654 14.3394 21.601 12.2347C23.5682 9.70329 23.2586 6.10219 20.7105 3.98433C18.1624 1.86647 14.8714 2.47272 12.8721 4.81013Z",
    stroke: "#B8C5CC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.c9c4d81f02d3c882297236d7a7d51f58.svg";
export { ForwardRef as ReactComponent };